//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getDefaultInstagramAccount = (state: ICuralateStore) =>
  state.instagram.account.defaultInstagramAccount;

export const getDefaultInstagramAccountUsername = createSelector(
  getDefaultInstagramAccount,
  (defaultInstagramAccount) => defaultInstagramAccount?.username,
);

export const getDefaultInstagramAccountImageUrl = createSelector(
  getDefaultInstagramAccount,
  (defaultInstagramAccount) => defaultInstagramAccount?.profileImageUrl,
);

export const getInstagramAccount = (state: ICuralateStore) =>
  state.instagram.account;

export const getIsFetchingDefaultInstagramAccount = createSelector(
  getInstagramAccount,
  (instagramAccount) => instagramAccount.isFetchingDefaultInstagramAccount,
);
